//
// PickResultEntryDisplayRuleIndicator.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../rules/RuleDisplayIndicatorType";

var PickResultEntryDisplayRuleIndicator = createModule("commons::PickResultEntryDisplayRuleIndicator", [], ClosetObject, [
    ,
    ,
    ,
    {
        indicator: 4,
        imageId: 7,
        icon: 7,
        swatchColor: 10,
        sampleText: 7,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default PickResultEntryDisplayRuleIndicator;
